// Global Instructions Rule Applied!

import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

// One campaign-level Cc/Bcc copy recipient — a fixed address copied on every
// message the campaign sends (distinct from the primary email_recipients send
// list and the per-recipient to|cc role).
//
// contact_id + contact_name are set when the address was chosen from the
// contact directory; both null for a manually-typed email. email_address is
// always the address that will be sent to. Short-keyed to match the elements
// emitted by view__email_campaign_copies AND embedded in
// view__email_campaign_detail (email_campaigns__cc_recipients / _bcc_recipients).
//
// .strict() rejects unknown keys so a future schema addition fails loudly
// until the model is extended (CLAUDE.md: a response that fails validation is
// an error, not coerced).
export const EmailCampaignCopySchema = z
  .object({
    id: z.string(),
    contact_id: z.string().nullable().optional(),
    email_address: z.string(),
    contact_name: z.string().nullable().optional()
  })
  .strict()

export type EmailCampaignCopy = z.infer<typeof EmailCampaignCopySchema>
export type EmailCampaignCopyKind = 'cc' | 'bcc'

// GET /email/campaigns/:id/copies response payload + view__email_campaign_copies.
export const EmailCampaignCopiesSchema = z
  .object({
    cc: z.array(EmailCampaignCopySchema),
    bcc: z.array(EmailCampaignCopySchema)
  })
  .strict()

export type EmailCampaignCopies = z.infer<typeof EmailCampaignCopiesSchema>

export function validateEmailCampaignCopies(data: unknown): EmailCampaignCopies {
  return validateWithZodSchema(EmailCampaignCopiesSchema, data, 'email campaign copies')
}
